/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import TextInput from 'components/common/TextInput';
import Text from 'components/common/Text';
import Form from 'components/common/Form';
import TextLink, { MailToLink } from 'components/common/TextLink';
import { CancelSubmitFormControls } from '../../common/FormControls/CancelUpdateFormControls';

const MfaCodeEntryView = (props) => {
  return (
    <Form>
      <Text colorName="black" size="footnote">
        <FormattedMessage id="2FACodeEntry.codeSent.message.text" values={{ string1: props.displayMobileNumber }} />
      </Text>

      <section>
        <TextInput
          value={props.mfaCode}
          type="tel"
          label={<FormattedMessage id="2FACodeEntry.title.text" />}
          name="mobileNumber"
          onChange={props.onChange}
          onFocus={props.onFocus}
          initialFocus
          isInvalid={!!props.errorMessage}
          invalidHint={props.errorMessage}
          isClearable
          clearValue={() => { props.onChange(''); }}
        />
      </section>

      <section>
        {
          props.isResending
          ? <Text colorName="middle-gray" size="footnote"><FormattedMessage id="2FACodeEntry.resendingCode.message.text" /></Text>
          : (
              <TextLink size="footnote" onClick={props.onResendCode} className="theme-group accent color">
                <FormattedMessage id="2FACodeEntry.resendCode.button.label" />
              </TextLink>
            )
        }
      </section>

      <section>
        <FormattedMessage id="groups.content.email.button.label">
          {
            (email) => (
              <Text colorName="middle-gray" size="footnote">
                <FormattedMessage id="2FACodeEntry.help.message.text" />{' '}
                <FormattedMessage id="contact.emailAlias.backpack.help">
                  {
                    (email) => (
                      <MailToLink email={email} className="theme-group accent color">
                        <FormattedMessage id="2FACodeEntry.help.button.label" />
                      </MailToLink>
                    )
                  }
                </FormattedMessage>
              </Text>
            )
          }
        </FormattedMessage>
      </section>

      <CancelSubmitFormControls
        onCancel={props.goBack}
        onSubmit={props.submitMfaCode}
        isDisabled={!props.isMfaCodeGoodEnough}
      />
    </Form>
  );
}

export default MfaCodeEntryView;
